import React from 'react';
import { Search, ShoppingCart, HelpCircle, Facebook, PinIcon as Pinterest } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-brand-border sticky top-0 z-40 shadow-sm" data-id="element-404">
      <div className="max-w-7xl mx-auto px-4 py-3 lg:py-5" data-id="element-405">
        <div className="flex items-center justify-between gap-4 lg:gap-8" data-id="element-406">
          {/* Logo */}
          <a href="/" className="flex-shrink-0" data-id="element-407">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-10 lg:h-12 w-auto object-contain" data-id="element-408" />
          </a>

          {/* Desktop Search */}
          <div className="hidden lg:flex flex-1 max-w-2xl" data-id="element-409">
            <div className="relative w-full group" data-id="element-410">
              <input type="text" placeholder="Search products, brands, parts, or specs" className="w-full pl-4 pr-12 py-2.5 rounded-md border border-brand-border bg-brand-cream focus:bg-white focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green transition-all text-brand-charcoal placeholder-gray-500 font-medium group-hover:border-gray-300" data-id="element-411" />
              <button className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 bg-brand-green text-white rounded hover:bg-brand-green/90 transition-colors" data-id="element-412">
                <Search size={18} data-id="element-413" />
              </button>
            </div>
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-414">
            <a href="/ContactUs.html" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-green font-medium transition-colors" data-id="element-415">
              <HelpCircle size={18} className="text-brand-green" data-id="element-416" />
              <span data-id="element-417">Help Choosing</span>
            </a>

            {/* Social icons removed as requested */}

            <button className="flex items-center gap-2 bg-white px-4 py-2 rounded-md border border-brand-border hover:border-brand-green hover:bg-brand-cream transition-colors font-medium" data-id="element-418">
              <ShoppingCart size={18} className="text-brand-green" data-id="element-419" />
              <span data-id="element-420">Cart $0.00</span>
            </button>
          </div>

          {/* Mobile Cart */}
          <div className="lg:hidden flex items-center" data-id="element-421">
            <button className="relative p-2 text-brand-charcoal hover:text-brand-green transition-colors" data-id="element-422">
              <ShoppingCart size={24} data-id="element-423" />
              <span className="absolute top-0 right-0 bg-brand-red text-white text-[10px] font-bold h-4 w-4 rounded-full flex items-center justify-center" data-id="element-424">
                0
              </span>
            </button>
          </div>
        </div>

        {/* Mobile Search (Below Header) */}
        <div className="mt-3 lg:hidden" data-id="element-425">
          <div className="relative w-full" data-id="element-426">
            <input type="text" placeholder="Search products, brands, parts..." className="w-full pl-4 pr-12 py-2.5 rounded-md border border-brand-border bg-brand-cream focus:bg-white focus:border-brand-green focus:outline-none text-brand-charcoal font-medium" data-id="element-427" />
            <button className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 bg-brand-green text-white rounded" data-id="element-428">
              <Search size={16} data-id="element-429" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}